(() => {
  if (!customElements.get('slider-component')) {
    class SliderComponent extends HTMLElement {
      constructor() {
        super();
        this.slider = this.querySelector('[id^="Slider-"]');
        this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
        this.enableSliderLooping = false;
        this.currentPageElement = this.querySelector('.slider-counter--current');
        this.pageTotalElement = this.querySelector('.slider-counter--total');
        this.prevButton = this.querySelector('button[name="previous"]');
        this.nextButton = this.querySelector('button[name="next"]');
        if (!this.slider || !this.nextButton) return;

        this.initPages();
        new ResizeObserver(() => this.initPages()).observe(this.slider);

        this.slider.addEventListener('scroll', this.update.bind(this));
        this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
        this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
      }
      initPages() {
        this.sliderItemsToShow = Array.from(this.sliderItems).filter((el) => el.clientWidth > 0);
        if (this.sliderItemsToShow.length < 2) return;
        this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
        this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
        this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
        this.update();
      }
      update() {
        if (!this.slider || !this.nextButton) return;
        const prev = this.currentPage;
        this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;
        if (this.currentPageElement && this.pageTotalElement) {
          this.currentPageElement.textContent = this.currentPage;
          this.pageTotalElement.textContent = this.totalPages;
        }
        if (!this.enableSliderLooping) {
          if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
            this.prevButton.setAttribute('disabled', 'disabled');
          } else {
            this.prevButton.removeAttribute('disabled');
          }
          if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
            this.nextButton.setAttribute('disabled', 'disabled');
          } else {
            this.nextButton.removeAttribute('disabled');
          }
        }
        if (this.currentPage !== prev) {
          this.dispatchEvent(new CustomEvent('slideChanged', {
            detail: { currentPage: this.currentPage, currentElement: this.sliderItemsToShow[this.currentPage - 1] }
          }));
        }
      }
      isSlideVisible(el, offset = 0) {
        const last = this.slider.clientWidth + this.slider.scrollLeft - offset;
        return el.offsetLeft + el.clientWidth <= last && el.offsetLeft >= this.slider.scrollLeft;
      }
      onButtonClick(e) {
        e.preventDefault();
        const step = e.currentTarget.dataset.step || 1;
        this.slideScrollPosition =
          e.currentTarget.name === 'next'
            ? this.slider.scrollLeft + step * this.sliderItemOffset
            : this.slider.scrollLeft - step * this.sliderItemOffset;
        this.setSlidePosition(this.slideScrollPosition);
      }
      setSlidePosition(left) { this.slider.scrollTo({ left }); }
    }
    customElements.define('slider-component', SliderComponent);
  }

  if (!customElements.get('slideshow-component')) {
    class SlideshowComponent extends customElements.get('slider-component') {
      constructor() {
        super();
        this.sliderControlWrapper = this.querySelector('.slider-buttons');
        this.enableSliderLooping = true;
        if (!this.sliderControlWrapper) return;

        this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
        if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

        this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
        this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
        this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
        this.setSlideVisibility();
      }
      onButtonClick(e) {
        super.onButtonClick(e);
        const isFirst = this.currentPage === 1;
        const isLast  = this.currentPage === this.sliderItemsToShow.length;
        if (isFirst && e.currentTarget.name === 'previous') {
          this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
        } else if (isLast && e.currentTarget.name === 'next') {
          this.slideScrollPosition = 0;
        }
        this.setSlidePosition(this.slideScrollPosition);
      }
      setSlideVisibility() {
        this.sliderItemsToShow.forEach((item, i) => {
          const links = item.querySelectorAll('a');
          const active = i === this.currentPage - 1;
          links.forEach((a) => a.setAttribute('tabindex', active ? '0' : '-1'));
          item.setAttribute('aria-hidden', active ? 'false' : 'true');
          item.toggleAttribute('tabindex', !active);
        });
      }
      linkToSlide(e) {
        e.preventDefault();
        const pos = this.slider.scrollLeft +
          this.sliderFirstItemNode.clientWidth *
          (this.sliderControlLinksArray.indexOf(e.currentTarget) + 1 - this.currentPage);
        this.slider.scrollTo({ left: pos });
      }
    }
    customElements.define('slideshow-component', SlideshowComponent);
  }
})();